export default class Overflow {
    constructor(component) {
        this.component = component;

        this.init();
    }

    checkOverflow() {
        return this.component.scrollWidth > this.component.clientWidth;
    }

    checkButtonVisibility(root) {
        if (!root) return;

        root.overflowButtons[0].style.opacity = root.component.scrollLeft < 1 ? 0 : 1;
        root.overflowButtons[1].style.opacity = root.component.scrollLeft >= root.component.scrollWidth - root.component.clientWidth ? 0 : 1;
    }

    bindHandlers() {
        const root = this;
        let isScrolling;

        this.component.addEventListener('scroll', () => {
            window.clearTimeout(isScrolling);

            isScrolling = setTimeout(function() {
                root.checkButtonVisibility(root);
            }, 66);
        });

        this.component.addEventListener('click', event => {
            if (!this.checkOverflow()) return;

            if (event.target.closest('[data-overflow-direction]')) {
                if (event.target.closest('[data-overflow-direction]').getAttribute('data-overflow-direction') === 'left') {
                    this.component.scrollLeft -= this.component.clientWidth * 0.75;
                } else {
                    this.component.scrollLeft += this.component.clientWidth * 0.75;
                }

                this.checkButtonVisibility();
            } else if (event.target.matches('[data-overflow-trigger]')) {
                this.component.scrollLeft = event.target.offsetLeft - 100;
            }
        });
    }

    addButtons() {
        this.overflowButtons = [];

        for (let index = 0; index < 2; index += 1) {
            const button = document.createElement('button');

            button.setAttribute('class', 'overflow__button button border-radius-100');
            button.setAttribute('type', 'button');
            button.setAttribute('data-overflow-direction', (index === 0 ? 'left' : 'right'));
            button.innerHTML = '<svg width="14" height="8" fill="#006FB7"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.99994 7.60002l.82202-.72392L12 2.2848 10.356.400024 6 4.26089 1.64403.400024.00000182 2.2848 5.17804 6.8761l.8219.72392z"></path></svg>';
            if (index === 0) button.style.opacity = 0;

            this.overflowButtons.push(button);
        }

        this.component.prepend(this.overflowButtons[0]);
        this.component.append(this.overflowButtons[1]);
    }

    init() {
        this.component.classList.add('overflow');
        
        if (this.checkOverflow()) {
            this.addButtons();
            this.bindHandlers();
        }

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if (this.checkOverflow()) {
                    this.bindHandlers();

                    this.component.classList.add('overflow');
                    if (this.overflowButtons) this.overflowButtons.forEach(button => button.style.display = '');
                } else {
                    this.component.classList.remove('overflow');
                    if (this.overflowButtons) this.overflowButtons.forEach(button => button.style.display = 'none');
                }
            }, 250);
        });
    }
}